<script>
import {defineComponent} from 'vue'
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import CatalogComponent from "@js/components/Sections/Catalog/CatalogComponent.vue";
import {useCatalogStore} from "@js/store/CatalogStore.js";
import IconSearch from "@js/components/Icons/IconSearch.vue";

export default defineComponent({
    name: "SearchPage",
    components: {IconSearch, CatalogComponent, MobileTopBar, Breadcrumbs},
    beforeUnmount() {
        if (this.catalogStore.search_query) {
            this.catalogStore.search_query = null
        }
    },
    setup() {
        const catalogStore = useCatalogStore()

        return {catalogStore}
    }
})
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <h1 class="flex items-center text-xl md:text-2xl font-medium mb-5">
            Результаты поиска
            <template v-if="catalogStore.search_query">
                по запросу "{{ catalogStore.search_query }}"
            </template>
        </h1>
    </div>
    <CatalogComponent/>
</template>

<style scoped lang="scss">

</style>
